'use strict';

exports.__esModule = true;

var _kindergarten = require('kindergarten');

Object.keys(_kindergarten).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _kindergarten[key];
    }
  });
});

var _install = require('./vue-kindergarten/install');

var _install2 = _interopRequireDefault(_install);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = { install: _install2.default };


//////////////////
// WEBPACK FOOTER
// ./~/vue-kindergarten/lib/index.js
// module id = Ar/W
// module chunks = 0